import CustomPortal from "../../CustomPortal";
import SendEmailCode from '../../reset-password-component/SendEmailCode';

const ForgetPasswordForm = () => {
    return (
        <CustomPortal
            header="Forgot password"
            Component={SendEmailCode}
        />
    );
}

export default ForgetPasswordForm;